module.exports = __webpack_public_path__ + "img/prev_arredo.94dc87dc.png";